import config from "./config.json";

const environment = process.env.REACT_APP_ENV || "local";

const environmentConfig = config[environment];

if (!environmentConfig) {
  throw new Error(`Invalid REACT_APP_ENV: ${environment}`);
}

export default environmentConfig;